import { useCallback } from 'react';
export default function useMailTo() {
    const mailTo = useCallback((to, subject, body) => {
        window.open(`mailto:${to}?subject=${encodeURIComponent(subject) || ''}&body=${encodeURIComponent(body) || ''}`);
    }, []);
    return mailTo;
}
